module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_8004.ce6af6b3.png";